import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { LoadingButton } from "@mui/lab";

export default function MedicareInsuranceCard({
  onSubmit,
  loading,
}: {
  loading?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (isMedicareOriginal: boolean) => Promise<void>;
}) {
  const handleMedicareOriginalSelection = async (
    isMedicareOriginal: boolean,
  ) => {
    await onSubmit(isMedicareOriginal);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        my: 1,
      }}
    >
      <Typography
        variant="h1"
        align="center"
        color="primary"
        sx={{
          fontFamily: "JazminAltLight",
          fontSize: "26px",
          lineHeight: "31.2px",
          marginTop: 1,
          mt: 1,
        }}
      >
        Do you have Original Medicare?
      </Typography>
      <Typography
        variant="h3"
        color="primary"
        align="center"
        sx={{
          my: 2,
          fontSize: "16px",
          fontFamily: "ABCDiaTypeRegular",
          fontWeight: "400",
        }}
      >
        Your insurance card will look like this.
      </Typography>
      <Image
        src="/provider/medicare-original-card.png"
        layout="intrinsic"
        alt="Medicare Original Card"
        width={377}
        height={251}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          mt: 3,
          width: "100%",
        }}
      >
        <LoadingButton
          disabled={loading}
          loading={loading}
          fullWidth
          size="large"
          variant={"contained"}
          onClick={async () => await handleMedicareOriginalSelection(true)}
        >
          Yes
        </LoadingButton>
        <LoadingButton
          disabled={loading}
          loading={loading}
          fullWidth
          variant={"contained"}
          size="large"
          onClick={async () => await handleMedicareOriginalSelection(false)}
        >
          No*
        </LoadingButton>
      </Box>
      <Typography
        align="center"
        sx={{ my: 2, fontSize: "14px", maxWidth: "350px" }}
      >
        *If not, then please select NO. You likely have Medicare Advantage
        through another insurance provider.
      </Typography>
    </Box>
  );
}
